import React from 'react'
import { Link } from 'react-router-dom'

const Info = () => {
  return (
    <div className='text-center my-6 max-w-2xl mx-auto px-4'>
        <h1 className='text-2xl mb-6'>利用に関する規約等</h1>

        <Link to='/info/terms' className='block p-4 my-4 bg-white rounded-lg shadow-sm hover:bg-gray-100'>利用規約</Link>
        <Link to='/info/privacy' className='block p-4 my-4 bg-white rounded-lg shadow-sm hover:bg-gray-100'>プライバシーポリシー</Link>
        <Link to='/info/notations_sct' className='block p-4 my-4 bg-white rounded-lg shadow-sm hover:bg-gray-100'>特定商取引法に基づく表示</Link>
    </div>
  )
}

export default Info